import { computed } from 'vue'

import { PLATFORM_SETUP_STATUS } from '@/features/admin/platform-setup/constants'
import { isSetupDismissed } from '@/features/admin/platform-setup/utils/dismissal'
import { RoleEnumTypeV2 } from '@/features/auth/types'
import useProgramRoles from '@/features/users/hooks/use-program-roles.hook'
import useWhiteLabel from '@/hooks/use-white-label.hook'

/** Où en est la mise en route de la plateforme, vu par l'utilisateur courant. */
export default function usePlatformSetupStatus() {
  const { whiteLabelRef, isPendingRef: isWhiteLabelPendingRef } = useWhiteLabel()
  const { programRolesRef, isPendingRef: isRolesPendingRef } = useProgramRoles()

  // Seul un super admin (ADMIN + SUPPORT) règle la plateforme ; un admin de programme gère son programme.
  const isPlatformAdminRef = computed(
    () =>
      !!programRolesRef.value?.includes(RoleEnumTypeV2.ADMIN) &&
      !!programRolesRef.value?.includes(RoleEnumTypeV2.SUPPORT),
  )
  const statusRef = computed(() => whiteLabelRef.value.platformSetupStatus)
  const isReadyRef = computed(() => !isWhiteLabelPendingRef.value && !isRolesPendingRef.value)

  // Plateforme créée avec l'assistant (les anciennes n'ont pas de statut).
  const isTrackedRef = computed(
    () => statusRef.value === PLATFORM_SETUP_STATUS.PENDING || statusRef.value === PLATFORM_SETUP_STATUS.COMPLETED,
  )

  const shouldOpenWizardRef = computed(
    () =>
      isReadyRef.value &&
      isPlatformAdminRef.value &&
      statusRef.value === PLATFORM_SETUP_STATUS.PENDING &&
      !isSetupDismissed(),
  )

  return { isPlatformAdminRef, isTrackedRef, shouldOpenWizardRef }
}
